;
define("facets_items_collection_view_cell.tpl", function(){});

